import { getConfig } from '@/utils/config'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useConfigStore = defineStore('configStore', () => {
  const authConfig = ref({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: getConfig('VITE_AUTH0_CLIENT_ID'),
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin
  })

  function setAuthClientId(clientId) {
    if (clientId) {
      authConfig.value.clientId = clientId
    }
  }

  function resetAuthConfig() {
    authConfig.value = {
      domain: import.meta.env.VITE_AUTH0_DOMAIN,
      clientId: getConfig('VITE_AUTH0_CLIENT_ID'),
      redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin
    }
  }

  const features = ref([])

  function setFeatures(feats) {
    if (feats) {
      features.value = feats
    }
  }

  return {
    authConfig: computed(() => authConfig.value),
    setAuthClientId,
    resetAuthConfig,
    features,
    setFeatures
  }
})